import { render, staticRenderFns } from "./ipChecker.vue?vue&type=template&id=48fd777a&scoped=true"
import script from "./ipChecker.vue?vue&type=script&lang=js"
export * from "./ipChecker.vue?vue&type=script&lang=js"
import style0 from "./ipChecker.vue?vue&type=style&index=0&id=48fd777a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fd777a",
  null
  
)

export default component.exports